// SFW adjectives
export const ADJECTIVES = [
  'Adorable',
  'Adventurous',
  'Aggressive',
  'Agreeable',
  'Alert',
  'Alive',
  'Amused',
  'Angry',
  'Annoyed',
  'Annoying',
  'Anxious',
  'Arrogant',
  'Ashamed',
  'Attractive',
  'Average',
  'Beautiful',
  'Better',
  'Bewildered',
  'Blue',
  'Blushing',
  'Bored',
  'Brainy',
  'Brave',
  'Breakable',
  'Bright',
  'Busy',
  'Calm',
  'Careful',
  'Cautious',
  'Charming',
  'Cheerful',
  'Clean',
  'Clear',
  'Clever',
  'Cloudy',
  'Clumsy',
  'Colorful',
  'Comfortable',
  'Concerned',
  'Confused',
  'Cooperative',
  'Courageous',
  'Crazy',
  'Creepy',
  'Crowded',
  'Curious',
  'Cute',
  'Dangerous',
  'Dark',
  'Defiant',
  'Delightful',
  'Depressed',
  'Determined',
  'Different',
  'Difficult',
  'Disgusted',
  'Distinct',
  'Disturbed',
  'Dizzy',
  'Doubtful',
  'Drab',
  'Dull',
  'Eager',
  'Easy',
  'Elated',
  'Elegant',
  'Embarrassed',
  'Enchanting',
  'Encouraging',
  'Energetic',
  'Enthusiastic',
  'Envious',
  'Evil',
  'Excited',
  'Expensive',
  'Exuberant',
  'Fair',
  'Faithful',
  'Famous',
  'Fancy',
  'Fantastic',
  'Fierce',
  'Fine',
  'Foolish',
  'Fragile',
  'Frail',
  'Frantic',
  'Friendly',
  'Frightened',
  'Funny',
  'Gentle',
  'Gifted',
  'Glamorous',
  'Gleaming',
  'Glorious',
  'Good',
  'Gorgeous',
  'Graceful',
  'Grumpy',
  'Handsome',
  'Happy',
  'Healthy',
  'Helpful',
  'Hilarious',
  'Homely',
  'Hungry',
  'Important',
  'Impossible',
  'Inexpensive',
  'Innocent',
  'Inquisitive',
  'Itchy',
  'Jealous',
  'Jittery',
  'Jolly',
  'Joyous',
  'Kind',
  'Lazy',
  'Light',
  'Lively',
  'Lonely',
  'Long',
  'Lovely',
  'Lucky',
  'Magnificent',
  'Misty',
  'Modern',
  'Motionless',
  'Muddy',
  'Mushy',
  'Mysterious',
  'Naughty',
  'Nervous',
  'Nice',
  'Nutty',
  'Obedient',
  'Obnoxious',
  'Odd',
  'Old-fashioned',
  'Open',
  'Outrageous',
  'Outstanding',
  'Panicky',
  'Perfect',
  'Plain',
  'Pleasant',
  'Poised',
  'Powerful',
  'Precious',
  'Prickly',
  'Proud',
  'Puzzled',
  'Quaint',
  'Real',
  'Relieved',
  'Scary',
  'Selfish',
  'Shiny',
  'Shy',
  'Silly',
  'Sleepy',
  'Smiling',
  'Smoggy',
  'Sparkling',
  'Splendid',
  'Spotless',
  'Stormy',
  'Strange',
  'Successful',
  'Super',
  'Talented',
  'Tame',
  'Tasty',
  'Tender',
  'Tense',
  'Terrible',
  'Thankful',
  'Thoughtful',
  'Thoughtless',
  'Tired',
  'Tough',
  'Uninterested',
  'Unsightly',
  'Unusual',
  'Upset',
  'Uptight',
  'Vast',
  'Victorious',
  'Vivacious',
  'Wandering',
  'Weary',
  'Wicked',
  'Wide-eyed',
  'Wild',
  'Witty',
  'Worried',
  'Worrisome',
  'Zany',
  'Zealous',
  'Uncooked' // ;)
]

export const NOUNS = [
  // Planets
  'Mercury',
  'Venus',
  'Earth',
  'Mars',
  'Jupiter',
  'Saturn',
  'Uranus',
  'Neptune',
  'Pluto',
  'Moon',
  'Sun',

  // Garden-themed nouns
  'Ant',
  'Bark',
  'Bee',
  'Bird',
  'Boot',
  'Branch',
  'Broom',
  'Bucket',
  'Bunny',
  'Bush',
  'Butterfly',
  'Cabbage',
  'Cactus',
  'Carrot',
  'Caterpillar',
  'Celery',
  'Chilli',
  'Cloud',
  'Clover',
  'Compost',
  'Concrete',
  'Cucumber',
  'Daffodil',
  'Daisy',
  'Dirt',
  'Fence',
  'Fertiliser',
  'Flower',
  'Flower Pot',
  'Fountain',
  'Frog',
  'Garden Bed',
  'Glove',
  'Gnome',
  'Grass',
  'Gravel',
  'Greenhouse',
  'Gumboot',
  'Hat',
  'Hedge',
  'Hose',
  'Ladybug',
  'Lawn Mower',
  'Leaf',
  'Leaf Blower',
  'Lilac',
  'Moss',
  'Mud',
  'Mulch',
  'Mushroom',
  'Onion',
  'Orchid',
  'Path',
  'Photosynthesis',
  'Pollen',
  'Pond',
  'Potato',
  'Rabbit',
  'Rain',
  'Raincoat',
  'Rake',
  'Rose',
  'Sapling',
  'Seed',
  'Shears',
  'Shed',
  'Shovel',
  'Snail',
  'Soil',
  'Spade',
  'Spider',
  'Sprinkler',
  'Sunshine',
  'Tomato',
  'Tool',
  'Tree',
  'Tulip',
  'Twig',
  'Water',
  'Watering Can',
  'Wheelbarrow',
  'Worm',

  // Spirit animals
  'Crab',
  'Dolphin',
  'Giraffe',
  'Marine Iguana',
  'Octopus',
  'Squid',
  'White Lion',
  'Cat'
]

export const randomProjectName = (): string => {
  if (Math.random() < 0.001) return 'James Harland'

  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
  const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
  return `${adj} ${noun}`
}
